import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService } from './config.service';

// Site users have no dashboard; send them to their home route instead.
export const dashboardAccessGuard: CanActivateFn = () => {
  const configService = inject(ConfigService);
  return configService.isSiteUser() ? inject(Router).parseUrl(configService.getHomeRoute()) : true;
};
